import { useEffect } from 'react';

import { useNavigation } from '@/modules/common/hooks';
import { showDebugProjectView } from '@/modules/debug';
import { ProjectsDashboard } from '@/modules/debug/components';
import { ModalManager } from '@common/components/ModalManager';
import { Box } from '@mui/system';

export function RedirectToPortal({ forceRedirect = false }: { forceRedirect?: boolean }) {
  const { goToPortal } = useNavigation();
  const shouldRedirect = forceRedirect || !showDebugProjectView;

  useEffect(() => {
    if (shouldRedirect) {
      goToPortal(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (shouldRedirect) {
    return null;
  }
  return (
    <Box>
      <ProjectsDashboard />
      <ModalManager />
    </Box>
  );
}
